import React, { useMemo } from "react";
import {
  Checkbox,
  MultiSelect,
  Text,
  Stack,
  Title,
} from "@mantine/core";
import {
  IA_LICENCE_TYPES,
  arraysToLicenceForms,
} from "../../data/quizLicenses";
import { SFC_LICENCE_TYPES } from "../../data/sfcLicences";

const toSelectedRoleIds = (targetRole) => {
  if (!targetRole || targetRole === "ALL") return [];
  if (Array.isArray(targetRole)) return targetRole.map(String);
  return [String(targetRole)];
};

const QuizParticipantSelector = ({ form, userRoles = [] }) => {
  const { iaForm, sfcForm } = arraysToLicenceForms(
    form.values.requiredLicenses,
    form.values.requiredSfcLicences
  );

  const roleOptions = useMemo(
    () =>
      userRoles.map((role) => ({
        value: String(role._id),
        label: role.name ?? role.cname ?? role._id,
      })),
    [userRoles]
  );

  const selectedRoles = toSelectedRoleIds(form.values.targetRole);

  const updateIa = (name, checked) => {
    const next = { ...iaForm, [name]: checked };
    form.setFieldValue(
      "requiredLicenses",
      Object.entries(next)
        .filter(([, v]) => v)
        .map(([k]) => k)
    );
  };

  const updateSfc = (name, checked) => {
    const next = { ...sfcForm, [name]: checked };
    form.setFieldValue(
      "requiredSfcLicences",
      Object.entries(next)
        .filter(([, v]) => v)
        .map(([k]) => k)
    );
  };

  return (
    <Stack spacing="md">
      <MultiSelect
        label="User Roles"
        description="Leave empty to include all roles"
        placeholder="All roles"
        data={roleOptions}
        value={selectedRoles}
        onChange={(values) => {
          form.setFieldValue("targetRole", values.length ? values : "ALL");
        }}
        searchable
        clearable
      />

      <Checkbox
        label="No Licence Need"
        checked={form.values.noLicenceNeed !== false}
        onChange={(event) =>
          form.setFieldValue("noLicenceNeed", event.currentTarget.checked)
        }
      />

      {form.values.noLicenceNeed === false && (
        <>
          <Title order={5}>IA Licences</Title>
          {IA_LICENCE_TYPES.map((lic) => (
            <Checkbox
              key={lic.name}
              label={lic.label}
              checked={!!iaForm[lic.name]}
              onChange={(event) =>
                updateIa(lic.name, event.currentTarget.checked)
              }
            />
          ))}

          <Title order={5} mt="md">
            SFC Licences
          </Title>
          {SFC_LICENCE_TYPES.map((lic) => (
            <Checkbox
              key={lic.name}
              label={lic.labelKey}
              checked={!!sfcForm[lic.name]}
              onChange={(event) =>
                updateSfc(lic.name, event.currentTarget.checked)
              }
            />
          ))}
          <Text size="sm" color="dimmed">
            Users need at least one selected IA or SFC licence (OR logic).
          </Text>
        </>
      )}
    </Stack>
  );
};

export default QuizParticipantSelector;
